import React from 'react';
import PageLayout from '../../components/layout/PageLayout';
import PlaceholderContent from '../../components/layout/PlaceholderContent';

function LDDashboard() {
  return (
    <PageLayout title="L&D Dashboard" subtitle="Learning & Development Center">
      <PlaceholderContent
        pageName="L&D Dashboard"
        description="Overview of training programs and development initiatives."
        features={[
          "Training completion metrics",
          "Certification tracking",
          "Learning path progress",
          "Training effectiveness analytics",
          "Development program overview"
        ]}
        expectedDate="Q1 2025"
      />
    </PageLayout>
  );
}

export default LDDashboard;